
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-12-06-tsl-drawing-lines",
      function () {
        return require("private-next-pages/blogs/2025-12-06-tsl-drawing-lines/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-12-06-tsl-drawing-lines"])
      });
    }
  